<script setup lang="ts">
import type { ToastCloseProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { X } from 'lucide-vue-next'
import { ToastClose } from 'reka-ui'

// `label` is the button's accessible name — it is icon-only. As in DialogContent,
// this layer has no i18n dependency, so the app passes the translated text in;
// English is the fallback. reka-ui keeps the close button out of the toast's
// screen-reader announcement, so the label is not read with every toast.
const props = defineProps<ToastCloseProps & {
  class?: HTMLAttributes['class']
  label?: string
}>()
const appConfig = useAppConfig()
const delegatedProps = computed(() => {
  const { class: _, label: __, ...delegated } = props
  return delegated
})
</script>

<template>
  <ToastClose v-bind="delegatedProps" :class="cn(appConfig.ui.toast.slots.close, props.class)">
    <X class="h-4 w-4" aria-hidden="true" />
    <span class="sr-only">{{ label ?? 'Close' }}</span>
  </ToastClose>
</template>
